export enum EDuration {
    MONTHS = 1,
    DAYS = 5,
}

export interface IVasTryAndBuy {
    cost: number,
    discount: number,
    duration: number,
    durationTypeId: EDuration,
    raId: number,
}

export interface IVasStopper {
    cost: number,
    discount: number,
    duration?: number,
    durationTypeId?: number,
    image: string,
    raId: number,
}

export interface IAdditionalProps {
    [key: string]: Record<string, unknown> | unknown[] | undefined,
}

export interface IPricesV2 {
    discount: number,
    duration: number | null,
    lifeTimePromoTypeId: EDuration | null,
    lifeTimePromo?: string,
    raGroups: number[],
    type: string | number,
    value: number,
    [key: string]: unknown,
}

export interface IPropContentData {
    asIs: number,
    name: string,
    title: string,
    type: string,
    title_short: string,
    value: Array<{
        title: string, value: string,
    }>,
}

export interface IContentData {
    alias: string,
    body: string,
    props?: IPropContentData[],
    title_short?: string,
    image_for_tariff_card?: string,
    image_widgets?: string,
    image?: string,
    title?: string,
    body_full?: string,
    [key: string]: unknown,
}

export interface IVasUrls {
    id: number,
    manual: number,
    name: string,
    owner_id: number,
    type: 'youtube' | 'doc' | 'landing',
    url: string,
}

export enum EVasesPromoCodes {
    /**
     * ContentTypeId игровых подписок
     */
    gamer = 13,
    voucher = 6,
    /**
     * SocId подписки GFN
     */
    gfn = 3152,
}

export interface IVasInfo<T = IAdditionalProps> {
    advertising: {
        companyName: string,
        erid: string,
    } | null,
    activeFrom: string,
    activeTo: string,
    activeVas: number,
    additionalProps: T,
    buttonText: string,
    buttonLink: string,
    camModules: string,
    changeDate: string,
    closeDateRa: string,
    contentData?: IContentData | null,
    connectPlans: string,
    contentTypeId: number,
    dateClose: string,
    flag: number,
    getPhone?: 0 | 1,
    image: string,
    imageWebp: string,
    includedAgr: number,
    materials: string,
    mobileVas: number,
    nameRa: string,
    nameVas: string,
    promocode: 1 | 0,
    priceRa: number,
    priceVas: number,
    pricesV2?: IPricesV2[],
    raId: number,
    serviceId: number,
    socId: number,
    stopper?: IVasStopper,
    tryAndBuy?: IVasTryAndBuy | null,
    type: string,
    urls: IVasUrls[],
    vasId: number,
}
